// @flow
import React, {type Node} from 'react';
import type {UserInputValidationError} from '@tectonics/prs/validation';
import {ErrorLabel} from '@tectonics/look-and-feel/volcanes/molecules/error-label';

type ValidationHintProps = {|
  error: UserInputValidationError,
  fieldName: string,
|}

export function ValidationHint({ error, fieldName }: ValidationHintProps): Node {
  if (!error) return null;

  if (error.id === 'empty') {
    return <ErrorLabel>Select your {fieldName}</ErrorLabel>;
  }

  return <ErrorLabel>Error in {fieldName} selection</ErrorLabel>;
}
